import { mount } from '../../../js/dom-lifecycle';

mount('.color-sample[data-bg-color]', function () {
    this.style.backgroundColor = this.dataset.bgColor;
});
